<template>
<span lang="mix"
      :data-odr-widget="$root.id"
      data-qa="odoro.widget"
      class="odr-main odr-main_chat">
    <keep-alive>
        <chat v-if="chatVars.opened" @close="close"/>
    </keep-alive>
</span>
</template>

<script type="ts">
import '@/utils/globals';
import globalMixin from '@/utils/mixins/global';
import { Component } from 'vue-property-decorator';
import Vue from 'vue';

@Component({
    mixins: [globalMixin],
    components: {
        chat: require('@/vue/chat.vue').default,
    },
})
export default class EntryChat extends Vue {
    chatVars = window.__odrChatVars

    mounted () {
        window.__odrChatVars.loaded = true;
    }

    close () {
        window.__odrChatVars.opened = false;
        this.$root.appConfig.chatClosedHook();
    }
};
</script>
